// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionReportFooterAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { withHandlers } from 'recompose';
import { curry } from 'lodash/fp';


/**
 * Permission Update Data
 * @param {Object} props
 * @param {Object} data
 * @param {String} value
 * @param {Object} event
 */
const permissionUpdateData = (props: any, data: any, value: string, event: any) => {
  props.permission.updateData(data, value, event.target.checked);
};

/**
 * Permission Update Tenant Access
 * @param {Object} props
 * @param {Object} data
 * @param {Object} value
 * @param {Object} event
 */
const permissionUpdateTenantAccess = (props: any, data: any, value: any, event: any) => {
  props.permission.updateTenantAccess(data, value, event.target.checked);
};

/**
 * Permission Update Schedule
 * @param {Object} props 
 * @param {Object} data 
 * @param {Event} value 
 */
const permissionUpdateReportActionSchedule = (props: Object, data: Object, event: Event) => {
  props.permission.updateReportActionSchedule(data, event.target.checked);
};

export default withHandlers({
  permissionUpdateData: curry(permissionUpdateData),
  permissionUpdateTenantAccess: curry(permissionUpdateTenantAccess),
  permissionUpdateReportActionSchedule: curry(permissionUpdateReportActionSchedule)
});


// WEBPACK FOOTER //
// ./ui/modules/Settings/PermissionTab/PermissionBody/Izenda.PermissionReportFooterActions.js